import { Select, MenuItem, styled, InputBase, SelectChangeEvent } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ProductType } from '@/data/types/Product';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';
import { useMemo } from 'react';
import { findProductAttribute } from 'integration/utils/findProductAttribute';

export const tallaOrder: Record<string, number> = {
	ech: 1,
	ch: 2,
	m: 3,
	g: 4,
	xg: 5,
};

const ProductSizeInput = styled(InputBase)({
	width: '95px !important',
	padding: '0px',
	'& .MuiInputBase-input': {
		position: 'relative',
		backgroundColor: '#FFFFFF',
		border: '1px solid #C9C9C9',
		fontSize: 'var(--font-size-small)',
		padding: '4px',
		borderRadius: '2px',
	},
	'& .MuiSelect-icon': {
		color: 'primary.main',
	},
	'&:hover': {
		backgroundColor: 'transparent',
	},
});

interface OutfitItemSizeProps {
	product: ProductType;
}

export const OutfitItemSize: React.FC<OutfitItemSizeProps> = ({ product }) => {
	const { availability, productsSelected, onSelectChildrenProduct } = useModalOutfitsContext();

	const sizes = useMemo(() => {
		if (!product.items.length || !availability.length) {
			return [];
		}

		return product.items
			.reduce<{ partNumber: string; size: string }[]>((acc, item) => {
				const availItem = availability.find((avail) => avail.productId === item.id);

				if (!availItem?.status) {
					return acc;
				}

				const size = findProductAttribute(item.attributes, 'Talla')?.value;

				if (size) {
					acc.push({ partNumber: item.partNumber, size });
				}
				return acc;
			}, [])
			.sort((a, b) => {
				const sizeALower = a.size.toLowerCase();
				const sizeBLower = b.size.toLowerCase();

				if (tallaOrder[sizeALower] && tallaOrder[sizeBLower]) {
					return tallaOrder[sizeALower] - tallaOrder[sizeBLower];
				}

				if (tallaOrder[sizeALower]) return -1;
				if (tallaOrder[sizeBLower]) return 1;

				const numA = Number(a.size);
				const numB = Number(b.size);

				if (!isNaN(numA) && !isNaN(numB)) {
					return numA - numB;
				}

				return a.size.localeCompare(b.size);
			});
	}, [product, availability]);

	const currentSelectedSize = productsSelected[product.partNumber] || 'talla';

	const handleOnSelectChildrenProduct = (event: SelectChangeEvent<string>) => {
		onSelectChildrenProduct(product.partNumber, event.target.value);
	};

	return (
		<Select
			value={currentSelectedSize}
			input={<ProductSizeInput />}
			IconComponent={KeyboardArrowDownIcon}
			sx={{
				height: '32px !important',
				'.MuiSelect-nativeInput': {
					padding: '0px',
				},
			}}
			MenuProps={{
				sx: {
					zIndex: 9999999999,
				},
			}}
			onChange={handleOnSelectChildrenProduct}
		>
			<MenuItem disabled value="talla">
				{'Talla'}
			</MenuItem>
			{sizes.map((size) => (
				<MenuItem key={size.partNumber} value={size.partNumber}>
					{size.size}
				</MenuItem>
			))}
		</Select>
	);
};
